import React, { useState } from 'react';
import styled from '@emotion/styled';
import * as constants from '../constants';

export const Modal: React.FC<{
  show: boolean;
  fadeDuration?: number;
  onClose?: () => void;
}> = props => {
  const { show, fadeDuration = 0.2, children, onClose } = props;

  const defaultState = {
    alpha: 0,
    isOnScreen: false,
    prevChildren: null,
  };

  const [state, setState] = useState<{
    alpha: number;
    isOnScreen: boolean;
    prevChildren: typeof children;
  }>(defaultState);

  const handleClose = () => {
    fadeOut();

    if (onClose) {
      onClose();
    }
  };

  const fadeIn = () => {
    setState({
      ...state,
      alpha: 1,
      isOnScreen: true,
      prevChildren: children,
    });
  };

  const fadeOut = () => {
    setState({
      ...state,
      alpha: 0,
    });

    setTimeout(() => {
      setState({
        alpha: 0,
        isOnScreen: false,
        prevChildren: null,
      });
    }, fadeDuration * 1000);
  };

  if (show && !state.isOnScreen) {
    fadeIn();
  } else if (!show && state.isOnScreen && state.alpha === 1) {
    fadeOut();
  }

  return (
    <ModalContainer
      onClick={handleClose}
      fadeDuration={fadeDuration}
      {...state}
    >
      <div
        className="inner"
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <span className="close-button" onClick={handleClose}>
          ×
        </span>
        {state.prevChildren}
      </div>
    </ModalContainer>
  );
};

export const ModalContainer = styled.div<{
  isOnScreen: boolean;
  alpha: number;
  fadeDuration: number;
}>`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: ${props => (props.isOnScreen ? 0 : -9999)}px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.55);
  transition: opacity ${props => props.fadeDuration}s linear;
  opacity: ${props => props.alpha};
  color: ${constants.contentTextColor};
  display: flex;

  .close-button {
    font-size: 24px;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  .inner {
    width: 100%;
    max-width: 740px;
    max-height: 100vh;
    background-color: #d9d6c3;
    padding: 60px;
    margin: auto;
    overflow: auto;
    position: relative;

    @media (max-width: 767.98px) {
      padding: 50px 1rem;
    }
  }
`;
